let API_DOMAIN = "http://localhost:3001";
let DOC_DOMAIN = "https://leap-int.epa.ie/docs";

switch (process.env.REACT_APP_EPA_ENV) {
  case "localhost":
    API_DOMAIN = "http://localhost:3001";
    DOC_DOMAIN = "https://data-int.epa.ie/docs";
    break;

  case "inttest":
    API_DOMAIN = "https://data-int.epa.ie/leap/api/v1";
    DOC_DOMAIN = "https://leap-int.edenireland.ie/docs";
    break;

  case "bustest":
    API_DOMAIN = "https://data-tst.epa.ie/leap/api/v1";
    DOC_DOMAIN = "https://leap-tst.edenireland.ie/docs";
    break;

  case "staging":
    API_DOMAIN = "https://data-stg.epa.ie/leap/api/v1";
    DOC_DOMAIN = "https://leap-stg.epa.ie/docs";
    break;

  case "production":
    API_DOMAIN = "https://data.epa.ie/leap/api/v1";
    DOC_DOMAIN = "https://leap.epa.ie/docs";
    break;
}
export const ENV = API_DOMAIN;
export const API_URL_ODATA = `${ENV}/odata`;
export const API_URL = `${ENV}`;

export const GetDocsUrl = (fileName: string) => {
  return `${DOC_DOMAIN}/${fileName}`;
};

export const GetRssUrl = (regNo: string) => {
  return `${DOC_DOMAIN}/rss/${regNo}.xml`;
};
